import React, { useState, useEffect } from 'react';
import useLearningAssignmentToolStore from '@/stores/AdminStore/LearningAssignmentToolStore';
import CreateAssignment from './components/CreateAssignment';
import AssignmentHistory from './components/AssignmentHistory';
import './LearningAssignmentTool.css';

const LearningAssignmentTool: React.FC = () => {
  const {
    users,
    learningItems,
    assignments,
    userProgress,
    fetchUsers,
    fetchLearningItems,
    fetchAssignments,
    fetchUserProgress,
  } = useLearningAssignmentToolStore();

  const [activeTab, setActiveTab] = useState<'create' | 'history' | 'dynamic'>('create');

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'create' && !users) {
      fetchUsers();
    }
    if (activeTab === 'create' && !learningItems) {
      fetchLearningItems();
    }
  }, [activeTab, users, learningItems, fetchUsers, fetchLearningItems]);

  useEffect(() => {
    if (activeTab === 'history' && !assignments) {
      fetchAssignments();
    }
    if (activeTab === 'history' && !userProgress) {
      fetchUserProgress();
    }
  }, [activeTab, assignments, userProgress, fetchAssignments, fetchUserProgress]);

  return (
    <div className="trainer-lat--container">
      <div className="trainer-lat--breadcrumb">
        <span className="trainer-lat--breadcrumb-item">User Management</span>
        <span className="trainer-lat--breadcrumb-separator">›</span>
        <span className="trainer-lat--breadcrumb-item lat-breadcrumb-active">Learning Assignment Tool</span>
      </div>

      <div className="trainer-lat--header">
        <h1 className="trainer-lat--title">Learning Assignment Tool</h1>
        <p className="trainer-lat--subtitle">Bulk-assign learning items to selected users efficiently</p>
      </div>

      <div className="trainer-lat--tabs">
        <button
          className={`trainer-lat--tab ${activeTab === 'create' ? 'trainer-lat--tab-active' : ''}`}
          onClick={() => setActiveTab('create')}
        >
          Create Assignment
        </button>
        <button
          className={`trainer-lat--tab ${activeTab === 'history' ? 'trainer-lat--tab-active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          Assignment History
        </button>
        <button
          className={`trainer-lat--tab ${activeTab === 'dynamic' ? 'trainer-lat--tab-active' : ''}`}
          onClick={() => setActiveTab('dynamic')}
        >
          Dynamic Assignments
        </button>
      </div>

      <div className="trainer-lat--content">
        {activeTab === 'create' && <CreateAssignment />}
        {activeTab === 'history' && <AssignmentHistory />}
        {activeTab === 'dynamic' && (
          <div className="trainer-lat--placeholder">
            <p>Dynamic Assignments content coming soon...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LearningAssignmentTool;
